import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Users, CalendarDays, Clock, Images, Newspaper, HeartHandshake, Mail, Sparkles, ArrowRight, HandCoins } from "lucide-react";

const cards = [
  { key: "members", label: "Members", icon: Users, to: "/admin/members", color: "#194324" },
  { key: "volunteers", label: "Volunteers", icon: HeartHandshake, to: "/admin/volunteers", color: "#2D623A" },
  { key: "donations", label: "Donations", icon: HandCoins, to: "/admin/donations", color: "#C59B27" },
  { key: "events", label: "Events", icon: CalendarDays, to: "/admin/events", color: "#C59B27" },
  { key: "schedules", label: "Schedule Entries", icon: Clock, to: "/admin/schedules", color: "#2D623A" },
  { key: "news", label: "News Posts", icon: Newspaper, to: "/admin/news", color: "#D9531E" },
  { key: "programs", label: "Activities", icon: Sparkles, to: "/admin/programs", color: "#C59B27" },
  { key: "enquiries", label: "Enquiries", icon: Mail, to: "/admin/enquiries", color: "#D9531E" },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#B38728] font-mono">Overview</p>
        <h1 className="font-display text-3xl md:text-4xl font-semibold text-[#194324]">Dashboard</h1>
        <p className="text-[#5C7264] mt-1">Manage every part of the trust website from one place.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((c) => (
          <Link key={c.key} to={c.to} className="group bg-white rounded-xl border border-[#E2DAD0] p-6 hover:border-[#C59B27] hover:shadow-md transition-all" data-testid={`stat-card-${c.key}`}>
            <div className="flex items-center justify-between">
              <div className="h-11 w-11 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${c.color}1a` }}><c.icon className="h-5 w-5" style={{ color: c.color }} /></div>
              <ArrowRight className="h-4 w-4 text-[#9CA99F] group-hover:text-[#C59B27] transition-colors" />
            </div>
            <div className="mt-4 text-3xl font-bold text-[#194324]">{stats[c.key] ?? 0}</div>
            <div className="text-sm text-[#5C7264]">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-10 bg-white rounded-xl border border-[#E2DAD0] p-6">
        <h2 className="font-display text-xl font-semibold text-[#194324] mb-3">Quick Actions</h2>
        <div className="flex flex-wrap gap-3">
          <Link to="/admin/content" className="px-4 py-2 rounded-full bg-[#194324] text-white text-sm font-medium hover:bg-[#2D623A]">Edit Site Content</Link>
          <Link to="/admin/events" className="px-4 py-2 rounded-full bg-[#C59B27] text-white text-sm font-medium hover:bg-[#A8811A]">Add Event</Link>
          <Link to="/admin/news" className="px-4 py-2 rounded-full border border-[#E2DAD0] text-[#194324] text-sm font-medium hover:border-[#C59B27]">Post News</Link>
          <Link to="/admin/programs" className="px-4 py-2 rounded-full border border-[#E2DAD0] text-[#194324] text-sm font-medium hover:border-[#C59B27]">Add Activity</Link>
          <Link to="/admin/gallery" className="px-4 py-2 rounded-full border border-[#E2DAD0] text-[#194324] text-sm font-medium hover:border-[#C59B27]">Add Photo</Link>
        </div>
      </div>
    </div>
  );
}
